import React, {useState} from 'react'
import './DemoCard.scss'
import {CountdownCircleTimer} from "react-countdown-circle-timer";
import { ArrowRightIcon } from '@heroicons/react/outline'
import Confetti from 'react-confetti'
import GameOver from '../../assets/assets_audio_game_over_sound.mp3'
import Complete from '../../assets/assets_audio_level_complete.mp3'
import Correct from '../../assets/assets_audio_correct_answer_chyme.mp3'


export const DemoCard = () => {
    const [questionNumber,setQuestionNumber] = useState(0)
    const questions = [
        {
            question:"First English player to score a Premier League hat trick",
            options:[
                "Alan Shearer",
                "Mark Robins",
                "Wayne Rooney",
                "Chris Sutton",
            ],
            correct:1
        },
        {
            question:"Which club do you associate Nat Lofthouse with",
            options:[
                "Bolton Wanderers",
                "Blackburn Rovers",
                "Oldham Athletic",
                "Wigan Athletic",
            ],
            correct:0
        },
        {
            question:"The only team to lose 9+ goals in Premier League era twice",
            options:[
                "Ipswich Town",
                "Southampton",
                "Leicester City",
                "Wigan Athletic",
            ],
            correct:1
        },
        {
            question:"Who scored the fastest goal in Premier League",
            options:[
                "Ledley King",
                "Alan Sheare",
                "Shane Long",
                "Christian Eriksen",
            ],
            correct:2
        },
        {
            question:"Who won the first division title with Everton as both player and manager",
            options:[
                "Howard Kendall",
                "Harry Catterick",
                "Neville Southall",
                "Colin Harvey",
            ],
            correct:0
        },
    ]
    const [isTimer, setIsTimer] = useState(false)
    const [isClick, setIsClick] = useState(false)
    const [isWrong, setIsWrong] = useState(99)
    const [next,setNext] = useState(true)
    const [confetti,setConfetti] = useState(false)
    const [duration,setDuration] = useState(10)
    const [nextText,setNextText] = useState("Next")
    const [confettiTime, setConfettiTime] = useState(false)


    const urlGameOver = GameOver;
    const  audioGameOver = new Audio(urlGameOver);



    const playGameOver = () => {
        audioGameOver.play()
    }
    const urlCorrect = Correct;
    const  audioCorrect = new Audio(urlCorrect);



    const playCorrect = () => {
        audioCorrect.play()
    }
    const urlLevelComplete = Complete;
    const  audioLevelComplete = new Audio(urlLevelComplete);



    const playLevelComplete = () => {
        audioLevelComplete.play()
    }

    const checkCorrect =(option) => {

        if(isClick === false){
            setIsClick(() => true)
            setIsTimer(() => false)
            if(option !== questions[questionNumber].correct){
                // setQuestionNumber(() => questionNumber + 1)
                setIsWrong(() => option)
                playGameOver()
                setNext(() => false)
                setIsTimer(() => false)
            }
            else{
                if(option === questions[questionNumber].correct){
                    // setQuestionNumber(() => questionNumber + 1)

                    if(questionNumber !== 4){
                        playCorrect()
                        setNext(() => true)


                    }else{
                        playLevelComplete()
                        setConfetti(() => true)
                        setConfettiTime(() => true)
                        setNextText(() => "Play Again")
                        setDuration(() => duration + 1)
                        setIsTimer(() => false)
                        setTimeout(() => {
                            setConfetti(() => false)
                        },2000)
                        setTimeout(() => {
                            setConfettiTime(() => false)
                        },5000)








                    }
                }

            }
        }

    }

    const nextMove = (method) => {
        setIsWrong(() => 99)
        setIsClick(() => false)
        if(method === "Next"){
            if(questionNumber <4){
                setQuestionNumber(() => questionNumber + 1)
                setIsTimer(() => true)
                setDuration(() => duration + 1)
            }
        }
        else if(method === "retry"){
            setQuestionNumber(() => 0)
            setIsTimer(() => true)
            setDuration(() => duration + 1)

        }
        else{
            setQuestionNumber(() => 0)
            setIsTimer(() => true)
            setDuration(() => duration + 1)
            setNextText(() => "Next")


        }
    }

    return (
        <div className='demo-card-container'>
            <div className='demo-card'>
                <div className="quiz-card">
                    <div className="pc">
                        <Confetti
                            width={500}
                            wind={0}
                            gravity={0.2}
                            run={confettiTime}
                            recycle={confetti}
                            numberOfPieces={500}
                        />
                    </div>
                    <div className="timer-container">
                        <CountdownCircleTimer
                            // isPlaying
                            isPlaying={isTimer}
                            size={90}
                            strokeWidth={6}
                            duration={10}
                            key={duration}
                            colors={'#1BA742'}
                            onComplete={() => {
                                playGameOver()
                                setIsClick(() => true)
                                setNext(() => false)
                            }}
                        >
                            {renderTime}
                        </CountdownCircleTimer>
                    </div>
                    <div className="question-text mb-10 px-2">{questions[questionNumber].question}</div>
                    <div className="questions px-5 mb-5">
                        <div onClick={() => checkCorrect(0)} className={isClick ? questions[questionNumber].correct === 0 ? `question-card-bls theme border-none` : isWrong === 0 ? `question-card-bls bg-red-600` : `question-card` : `question-card` }>
                            {questions[questionNumber].options[0]}
                        </div>
                        <div onClick={() => checkCorrect(1)} className={isClick ? questions[questionNumber].correct === 1 ? `question-card-bls theme border-none` : isWrong === 1 ? `question-card-bls bg-red-600` : `question-card` : `question-card` }>
                            {questions[questionNumber].options[1]}
                        </div>
                        <div onClick={() => checkCorrect(2)} className={isClick ? questions[questionNumber].correct === 2 ? `question-card-bls theme border-none` : isWrong === 2 ? `question-card-bls bg-red-600` : `question-card` : `question-card` }>
                            {questions[questionNumber].options[2]}
                        </div>
                        <div onClick={() => checkCorrect(3)} className={isClick ? questions[questionNumber].correct === 3 ? `question-card-bls theme border-none ` : isWrong === 3 ? `question-car-bls bg-red-600` : `question-card` : `question-card` }>
                            {questions[questionNumber].options[3]}
                        </div>

                    </div>
                    <div className={isClick ? "next-button px-5" : "hide"}>
                        {next ? (
                            <div onClick={() => nextMove(nextText)} className={'fwd theme'}>{nextText} <ArrowRightIcon className=" ml-4 h-5 w-5" aria-hidden="true" /></div>
                        ) : (
                            <div onClick={() => nextMove("retry")} className={'fwd exit bg-red-600'}>Retry <ArrowRightIcon className=" ml-4 h-5 w-5" aria-hidden="true" /></div>
                        )}
                    </div>
                </div>
                <div className="card-bg2">

                </div>
                <div className="card-bg">

                </div>

            </div>

        </div>
    )
}

const renderTime = ({ remainingTime }) => {
    if (remainingTime === 0) {
        return <div className="time text-red-600 text-2xl font-bold ">0</div>;
    }

    return (
        <div className="timer">
            <div className="value">{remainingTime}</div>
        </div>
    );
};